import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homethirteen-main-banner',
  templateUrl: './homethirteen-main-banner.component.html',
  styleUrls: ['./homethirteen-main-banner.component.scss']
})
export class HomethirteenMainBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
